export interface Country {
    code: string;
    name: string;
    currency: string;
    flag: string;
}

export const countries: Country[] = [
    { code: 'AF', name: 'Afghanistan', currency: 'AFN', flag: '🇦🇫' },
    { code: 'AL', name: 'Albania', currency: 'ALL', flag: '🇦🇱' },
    { code: 'DZ', name: 'Algeria', currency: 'DZD', flag: '🇩🇿' },
    { code: 'AS', name: 'American Samoa', currency: 'USD', flag: '🇦🇸' },
    { code: 'AD', name: 'Andorra', currency: 'EUR', flag: '🇦🇩' },
    { code: 'AO', name: 'Angola', currency: 'AOA', flag: '🇦🇴' },
    { code: 'AI', name: 'Anguilla', currency: 'XCD', flag: '🇦🇮' },
    { code: 'AG', name: 'Antigua and Barbuda', currency: 'XCD', flag: '🇦🇬' },
    { code: 'AR', name: 'Argentina', currency: 'ARS', flag: '🇦🇷' },
    { code: 'AM', name: 'Armenia', currency: 'AMD', flag: '🇦🇲' },
    { code: 'AW', name: 'Aruba', currency: 'AWG', flag: '🇦🇼' },
    { code: 'AU', name: 'Australia', currency: 'AUD', flag: '🇦🇺' },
    { code: 'AT', name: 'Austria', currency: 'EUR', flag: '🇦🇹' },
    { code: 'AZ', name: 'Azerbaijan', currency: 'AZN', flag: '🇦🇿' },
    { code: 'BS', name: 'Bahamas', currency: 'BSD', flag: '🇧🇸' },
    { code: 'BH', name: 'Bahrain', currency: 'BHD', flag: '🇧🇭' },
    { code: 'BD', name: 'Bangladesh', currency: 'BDT', flag: '🇧🇩' },
    { code: 'BB', name: 'Barbados', currency: 'BBD', flag: '🇧🇧' },
    { code: 'BY', name: 'Belarus', currency: 'BYN', flag: '🇧🇾' },
    { code: 'BE', name: 'Belgium', currency: 'EUR', flag: '🇧🇪' },
    { code: 'BZ', name: 'Belize', currency: 'BZD', flag: '🇧🇿' },
    { code: 'BJ', name: 'Benin', currency: 'XOF', flag: '🇧🇯' },
    { code: 'BM', name: 'Bermuda', currency: 'BMD', flag: '🇧🇲' },
    { code: 'BT', name: 'Bhutan', currency: 'BTN', flag: '🇧🇹' },
    { code: 'BO', name: 'Bolivia', currency: 'BOB', flag: '🇧🇴' },
    { code: 'BA', name: 'Bosnia and Herzegovina', currency: 'BAM', flag: '🇧🇦' },
    { code: 'BW', name: 'Botswana', currency: 'BWP', flag: '🇧🇼' },
    { code: 'BR', name: 'Brazil', currency: 'BRL', flag: '🇧🇷' },
    { code: 'BN', name: 'Brunei', currency: 'BND', flag: '🇧🇳' },
    { code: 'BG', name: 'Bulgaria', currency: 'BGN', flag: '🇧🇬' },
    { code: 'BF', name: 'Burkina Faso', currency: 'XOF', flag: '🇧🇫' },
    { code: 'BI', name: 'Burundi', currency: 'BIF', flag: '🇧🇮' },
    { code: 'KH', name: 'Cambodia', currency: 'KHR', flag: '🇰🇭' },
    { code: 'CM', name: 'Cameroon', currency: 'XAF', flag: '🇨🇲' },
    { code: 'CA', name: 'Canada', currency: 'CAD', flag: '🇨🇦' },
    { code: 'CV', name: 'Cape Verde', currency: 'CVE', flag: '🇨🇻' },
    { code: 'KY', name: 'Cayman Islands', currency: 'KYD', flag: '🇰🇾' },
    { code: 'CF', name: 'Central African Republic', currency: 'XAF', flag: '🇨🇫' },
    { code: 'TD', name: 'Chad', currency: 'XAF', flag: '🇹🇩' },
    { code: 'CL', name: 'Chile', currency: 'CLP', flag: '🇨🇱' },
    { code: 'CN', name: 'China', currency: 'CNY', flag: '🇨🇳' },
    { code: 'CO', name: 'Colombia', currency: 'COP', flag: '🇨🇴' },
    { code: 'KM', name: 'Comoros', currency: 'KMF', flag: '🇰🇲' },
    { code: 'CG', name: 'Congo', currency: 'XAF', flag: '🇨🇬' },
    { code: 'CD', name: 'Congo, Democratic Republic', currency: 'CDF', flag: '🇨🇩' },
    { code: 'CK', name: 'Cook Islands', currency: 'NZD', flag: '🇨🇰' },
    { code: 'CR', name: 'Costa Rica', currency: 'CRC', flag: '🇨🇷' },
    { code: 'HR', name: 'Croatia', currency: 'EUR', flag: '🇭🇷' },
    { code: 'CU', name: 'Cuba', currency: 'CUP', flag: '🇨🇺' },
    { code: 'CY', name: 'Cyprus', currency: 'EUR', flag: '🇨🇾' },
    { code: 'CZ', name: 'Czech Republic', currency: 'CZK', flag: '🇨🇿' },
    { code: 'DK', name: 'Denmark', currency: 'DKK', flag: '🇩🇰' },
    { code: 'DJ', name: 'Djibouti', currency: 'DJF', flag: '🇩🇯' },
    { code: 'DM', name: 'Dominica', currency: 'XCD', flag: '🇩🇲' },
    { code: 'DO', name: 'Dominican Republic', currency: 'DOP', flag: '🇩🇴' },
    { code: 'EC', name: 'Ecuador', currency: 'USD', flag: '🇪🇨' },
    { code: 'EG', name: 'Egypt', currency: 'EGP', flag: '🇪🇬' },
    { code: 'SV', name: 'El Salvador', currency: 'USD', flag: '🇸🇻' },
    { code: 'GQ', name: 'Equatorial Guinea', currency: 'XAF', flag: '🇬🇶' },
    { code: 'ER', name: 'Eritrea', currency: 'ERN', flag: '🇪🇷' },
    { code: 'EE', name: 'Estonia', currency: 'EUR', flag: '🇪🇪' },
    { code: 'SZ', name: 'Eswatini', currency: 'SZL', flag: '🇸🇿' },
    { code: 'ET', name: 'Ethiopia', currency: 'ETB', flag: '🇪🇹' },
    { code: 'FJ', name: 'Fiji', currency: 'FJD', flag: '🇫🇯' },
    { code: 'FI', name: 'Finland', currency: 'EUR', flag: '🇫🇮' },
    { code: 'FR', name: 'France', currency: 'EUR', flag: '🇫🇷' },
    { code: 'GA', name: 'Gabon', currency: 'XAF', flag: '🇬🇦' },
    { code: 'GM', name: 'Gambia', currency: 'GMD', flag: '🇬🇲' },
    { code: 'GE', name: 'Georgia', currency: 'GEL', flag: '🇬🇪' },
    { code: 'DE', name: 'Germany', currency: 'EUR', flag: '🇩🇪' },
    { code: 'GH', name: 'Ghana', currency: 'GHS', flag: '🇬🇭' },
    { code: 'GI', name: 'Gibraltar', currency: 'GIP', flag: '🇬🇮' },
    { code: 'GR', name: 'Greece', currency: 'EUR', flag: '🇬🇷' },
    { code: 'GL', name: 'Greenland', currency: 'DKK', flag: '🇬🇱' },
    { code: 'GD', name: 'Grenada', currency: 'XCD', flag: '🇬🇩' },
    { code: 'GU', name: 'Guam', currency: 'USD', flag: '🇬🇺' },
    { code: 'GT', name: 'Guatemala', currency: 'GTQ', flag: '🇬🇹' },
    { code: 'GN', name: 'Guinea', currency: 'GNF', flag: '🇬🇳' },
    { code: 'GW', name: 'Guinea-Bissau', currency: 'XOF', flag: '🇬🇼' },
    { code: 'GY', name: 'Guyana', currency: 'GYD', flag: '🇬🇾' },
    { code: 'HT', name: 'Haiti', currency: 'HTG', flag: '🇭🇹' },
    { code: 'HN', name: 'Honduras', currency: 'HNL', flag: '🇭🇳' },
    { code: 'HK', name: 'Hong Kong', currency: 'HKD', flag: '🇭🇰' },
    { code: 'HU', name: 'Hungary', currency: 'HUF', flag: '🇭🇺' },
    { code: 'IS', name: 'Iceland', currency: 'ISK', flag: '🇮🇸' },
    { code: 'IN', name: 'India', currency: 'INR', flag: '🇮🇳' },
    { code: 'ID', name: 'Indonesia', currency: 'IDR', flag: '🇮🇩' },
    { code: 'IR', name: 'Iran', currency: 'IRR', flag: '🇮🇷' },
    { code: 'IQ', name: 'Iraq', currency: 'IQD', flag: '🇮🇶' },
    { code: 'IE', name: 'Ireland', currency: 'EUR', flag: '🇮🇪' },
    { code: 'IM', name: 'Isle of Man', currency: 'GBP', flag: '🇮🇲' },
    { code: 'IL', name: 'Israel', currency: 'ILS', flag: '🇮🇱' },
    { code: 'IT', name: 'Italy', currency: 'EUR', flag: '🇮🇹' },
    { code: 'JM', name: 'Jamaica', currency: 'JMD', flag: '🇯🇲' },
    { code: 'JP', name: 'Japan', currency: 'JPY', flag: '🇯🇵' },
    { code: 'JE', name: 'Jersey', currency: 'GBP', flag: '🇯🇪' },
    { code: 'JO', name: 'Jordan', currency: 'JOD', flag: '🇯🇴' },
    { code: 'KZ', name: 'Kazakhstan', currency: 'KZT', flag: '🇰🇿' },
    { code: 'KE', name: 'Kenya', currency: 'KES', flag: '🇰🇪' },
    { code: 'KI', name: 'Kiribati', currency: 'AUD', flag: '🇰🇮' },
    { code: 'KP', name: 'North Korea', currency: 'KPW', flag: '🇰🇵' },
    { code: 'KR', name: 'South Korea', currency: 'KRW', flag: '🇰🇷' },
    { code: 'KW', name: 'Kuwait', currency: 'KWD', flag: '🇰🇼' },
    { code: 'KG', name: 'Kyrgyzstan', currency: 'KGS', flag: '🇰🇬' },
    { code: 'LA', name: 'Laos', currency: 'LAK', flag: '🇱🇦' },
    { code: 'LV', name: 'Latvia', currency: 'EUR', flag: '🇱🇻' },
    { code: 'LB', name: 'Lebanon', currency: 'LBP', flag: '🇱🇧' },
    { code: 'LS', name: 'Lesotho', currency: 'LSL', flag: '🇱🇸' },
    { code: 'LR', name: 'Liberia', currency: 'LRD', flag: '🇱🇷' },
    { code: 'LY', name: 'Libya', currency: 'LYD', flag: '🇱🇾' },
    { code: 'LI', name: 'Liechtenstein', currency: 'CHF', flag: '🇱🇮' },
    { code: 'LT', name: 'Lithuania', currency: 'EUR', flag: '🇱🇹' },
    { code: 'LU', name: 'Luxembourg', currency: 'EUR', flag: '🇱🇺' },
    { code: 'MO', name: 'Macau', currency: 'MOP', flag: '🇲🇴' },
    { code: 'MK', name: 'North Macedonia', currency: 'MKD', flag: '🇲🇰' },
    { code: 'MG', name: 'Madagascar', currency: 'MGA', flag: '🇲🇬' },
    { code: 'MW', name: 'Malawi', currency: 'MWK', flag: '🇲🇼' },
    { code: 'MY', name: 'Malaysia', currency: 'MYR', flag: '🇲🇾' },
    { code: 'MV', name: 'Maldives', currency: 'MVR', flag: '🇲🇻' },
    { code: 'ML', name: 'Mali', currency: 'XOF', flag: '🇲🇱' },
    { code: 'MT', name: 'Malta', currency: 'EUR', flag: '🇲🇹' },
    { code: 'MH', name: 'Marshall Islands', currency: 'USD', flag: '🇲🇭' },
    { code: 'MQ', name: 'Martinique', currency: 'EUR', flag: '🇲🇶' },
    { code: 'MR', name: 'Mauritania', currency: 'MRU', flag: '🇲🇷' },
    { code: 'MU', name: 'Mauritius', currency: 'MUR', flag: '🇲🇺' },
    { code: 'YT', name: 'Mayotte', currency: 'EUR', flag: '🇾🇹' },
    { code: 'MX', name: 'Mexico', currency: 'MXN', flag: '🇲🇽' },
    { code: 'FM', name: 'Micronesia', currency: 'USD', flag: '🇫🇲' },
    { code: 'MD', name: 'Moldova', currency: 'MDL', flag: '🇲🇩' },
    { code: 'MC', name: 'Monaco', currency: 'EUR', flag: '🇲🇨' },
    { code: 'MN', name: 'Mongolia', currency: 'MNT', flag: '🇲🇳' },
    { code: 'ME', name: 'Montenegro', currency: 'EUR', flag: '🇲🇪' },
    { code: 'MS', name: 'Montserrat', currency: 'XCD', flag: '🇲🇸' },
    { code: 'MA', name: 'Morocco', currency: 'MAD', flag: '🇲🇦' },
    { code: 'MZ', name: 'Mozambique', currency: 'MZN', flag: '🇲🇿' },
    { code: 'MM', name: 'Myanmar', currency: 'MMK', flag: '🇲🇲' },
    { code: 'NA', name: 'Namibia', currency: 'NAD', flag: '🇳🇦' },
    { code: 'NR', name: 'Nauru', currency: 'AUD', flag: '🇳🇷' },
    { code: 'NP', name: 'Nepal', currency: 'NPR', flag: '🇳🇵' },
    { code: 'NL', name: 'Netherlands', currency: 'EUR', flag: '🇳🇱' },
    { code: 'NZ', name: 'New Zealand', currency: 'NZD', flag: '🇳🇿' },
    { code: 'NI', name: 'Nicaragua', currency: 'NIO', flag: '🇳🇮' },
    { code: 'NE', name: 'Niger', currency: 'XOF', flag: '🇳🇪' },
    { code: 'NG', name: 'Nigeria', currency: 'NGN', flag: '🇳🇬' },
    { code: 'NU', name: 'Niue', currency: 'NZD', flag: '🇳🇺' },
    { code: 'NF', name: 'Norfolk Island', currency: 'AUD', flag: '🇳🇫' },
    { code: 'MP', name: 'Northern Mariana Islands', currency: 'USD', flag: '🇲🇵' },
    { code: 'NO', name: 'Norway', currency: 'NOK', flag: '🇳🇴' },
    { code: 'OM', name: 'Oman', currency: 'OMR', flag: '🇴🇲' },
    { code: 'PK', name: 'Pakistan', currency: 'PKR', flag: '🇵🇰' },
    { code: 'PW', name: 'Palau', currency: 'USD', flag: '🇵🇼' },
    { code: 'PS', name: 'Palestine', currency: 'ILS', flag: '🇵🇸' },
    { code: 'PA', name: 'Panama', currency: 'PAB', flag: '🇵🇦' },
    { code: 'PG', name: 'Papua New Guinea', currency: 'PGK', flag: '🇵🇬' },
    { code: 'PY', name: 'Paraguay', currency: 'PYG', flag: '🇵🇾' },
    { code: 'PE', name: 'Peru', currency: 'PEN', flag: '🇵🇪' },
    { code: 'PH', name: 'Philippines', currency: 'PHP', flag: '🇵🇭' },
    { code: 'PL', name: 'Poland', currency: 'PLN', flag: '🇵🇱' },
    { code: 'PT', name: 'Portugal', currency: 'EUR', flag: '🇵🇹' },
    { code: 'PR', name: 'Puerto Rico', currency: 'USD', flag: '🇵🇷' },
    { code: 'QA', name: 'Qatar', currency: 'QAR', flag: '🇶🇦' },
    { code: 'RO', name: 'Romania', currency: 'RON', flag: '🇷🇴' },
    { code: 'RU', name: 'Russia', currency: 'RUB', flag: '🇷🇺' },
    { code: 'RW', name: 'Rwanda', currency: 'RWF', flag: '🇷🇼' },
    { code: 'KN', name: 'Saint Kitts and Nevis', currency: 'XCD', flag: '🇰🇳' },
    { code: 'LC', name: 'Saint Lucia', currency: 'XCD', flag: '🇱🇨' },
    { code: 'VC', name: 'Saint Vincent and the Grenadines', currency: 'XCD', flag: '🇻🇨' },
    { code: 'WS', name: 'Samoa', currency: 'WST', flag: '🇼🇸' },
    { code: 'SM', name: 'San Marino', currency: 'EUR', flag: '🇸🇲' },
    { code: 'ST', name: 'Sao Tome and Principe', currency: 'STN', flag: '🇸🇹' },
    { code: 'SA', name: 'Saudi Arabia', currency: 'SAR', flag: '🇸🇦' },
    { code: 'SN', name: 'Senegal', currency: 'XOF', flag: '🇸🇳' },
    { code: 'RS', name: 'Serbia', currency: 'RSD', flag: '🇷🇸' },
    { code: 'SC', name: 'Seychelles', currency: 'SCR', flag: '🇸🇨' },
    { code: 'SL', name: 'Sierra Leone', currency: 'SLL', flag: '🇸🇱' },
    { code: 'SG', name: 'Singapore', currency: 'SGD', flag: '🇸🇬' },
    { code: 'SK', name: 'Slovakia', currency: 'EUR', flag: '🇸🇰' },
    { code: 'SI', name: 'Slovenia', currency: 'EUR', flag: '🇸🇮' },
    { code: 'SB', name: 'Solomon Islands', currency: 'SBD', flag: '🇸🇧' },
    { code: 'SO', name: 'Somalia', currency: 'SOS', flag: '🇸🇴' },
    { code: 'ZA', name: 'South Africa', currency: 'ZAR', flag: '🇿🇦' },
    { code: 'ES', name: 'Spain', currency: 'EUR', flag: '🇪🇸' },
    { code: 'LK', name: 'Sri Lanka', currency: 'LKR', flag: '🇱🇰' },
    { code: 'SD', name: 'Sudan', currency: 'SDG', flag: '🇸🇩' },
    { code: 'SR', name: 'Suriname', currency: 'SRD', flag: '🇸🇷' },
    { code: 'SE', name: 'Sweden', currency: 'SEK', flag: '🇸🇪' },
    { code: 'CH', name: 'Switzerland', currency: 'CHF', flag: '🇨🇭' },
    { code: 'SY', name: 'Syria', currency: 'SYP', flag: '🇸🇾' },
    { code: 'TW', name: 'Taiwan', currency: 'TWD', flag: '🇹🇼' },
    { code: 'TJ', name: 'Tajikistan', currency: 'TJS', flag: '🇹🇯' },
    { code: 'TZ', name: 'Tanzania', currency: 'TZS', flag: '🇹🇿' },
    { code: 'TH', name: 'Thailand', currency: 'THB', flag: '🇹🇭' },
    { code: 'TL', name: 'Timor-Leste', currency: 'USD', flag: '🇹🇱' },
    { code: 'TG', name: 'Togo', currency: 'XOF', flag: '🇹🇬' },
    { code: 'TO', name: 'Tonga', currency: 'TOP', flag: '🇹🇴' },
    { code: 'TT', name: 'Trinidad and Tobago', currency: 'TTD', flag: '🇹🇹' },
    { code: 'TN', name: 'Tunisia', currency: 'TND', flag: '🇹🇳' },
    { code: 'TR', name: 'Turkey', currency: 'TRY', flag: '🇹🇷' },
    { code: 'TM', name: 'Turkmenistan', currency: 'TMT', flag: '🇹🇲' },
    { code: 'TV', name: 'Tuvalu', currency: 'AUD', flag: '🇹🇻' },
    { code: 'UG', name: 'Uganda', currency: 'UGX', flag: '🇺🇬' },
    { code: 'UA', name: 'Ukraine', currency: 'UAH', flag: '🇺🇦' },
    { code: 'AE', name: 'United Arab Emirates', currency: 'AED', flag: '🇦🇪' },
    { code: 'GB', name: 'United Kingdom', currency: 'GBP', flag: '🇬🇧' },
    { code: 'US', name: 'United States', currency: 'USD', flag: '🇺🇸' },
    { code: 'UY', name: 'Uruguay', currency: 'UYU', flag: '🇺🇾' },
    { code: 'UZ', name: 'Uzbekistan', currency: 'UZS', flag: '🇺🇿' },
    { code: 'VU', name: 'Vanuatu', currency: 'VUV', flag: '🇻🇺' },
    { code: 'VE', name: 'Venezuela', currency: 'VES', flag: '🇻🇪' },
    { code: 'VN', name: 'Vietnam', currency: 'VND', flag: '🇻🇳' },
    { code: 'YE', name: 'Yemen', currency: 'YER', flag: '🇾🇪' },
    { code: 'ZM', name: 'Zambia', currency: 'ZMW', flag: '🇿🇲' },
    { code: 'ZW', name: 'Zimbabwe', currency: 'ZWL', flag: '🇿🇼' }
];

// Extendable to full list of 200+ countries if needed
// For now, this covers the most active international tourism markets
// and all East African neighbors.

export const getAllCurrencies = () => {
    const currencies = new Set<string>();
    countries.forEach(c => currencies.add(c.currency));
    return Array.from(currencies).sort();
};

export const getCountryByCode = (code: string) => {
    return countries.find(c => c.code === code) || countries.find(c => c.code === 'US');
};
